import React from 'react';
import { Route, Redirect } from 'react-router-dom';

export const ProtectedRoute = ({component: Component, ...rest}) => {
    return (
        <Route 
            {...rest}
            render = {props => {
                if(localStorage.getItem('key')){
                    return <Component {...props} rest={rest} />
                } else {
                    return <Redirect to={
                        {
                            pathname: "/",
                            state: {
                                from: props.location
                            }
                        }
                    } />
                }
            }}
        />
    )
}

export const NonProtectedRoute = ({ component: Component, ...rest }) => {
    return (
        <Route
            {...rest}
            render={props => {
                if (!localStorage.getItem('key')) {
                    return <Component {...props} />
                } else {
                    return <Redirect to={
                        {
                            pathname: "/profilestatus",
                            state: {
                                from: props.location
                            }
                        }
                    } />
                }
            }}
        />
    )
}